import { Link, Outlet, useNavigate, useSearchParams } from 'react-router-dom'
import SocialLoginButtons from '../registration/social-login-buttons/SocialLoginButtons'
import AuthShell from 'src/components/elements/auth-shell/AuthShell'
import LoginForm from './form/LoginForm'

import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { Button, Loader } from 'src/components/ui'
import { ApproveRequestEmail } from './ApproveRequestEmail'
import { useGetUserQuery } from 'src/redux/api'

const Login = () => {
  const { t } = useTranslation()
  const [openApproveEmail, setOpenApproveEmail] = useState(false)
  const { data: user, isLoading: getUserLoading } = useGetUserQuery(undefined)
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()

  // The backend lands email-verification links here with a status in the
  // query string; surface it as a toast and clean the URL up.
  useEffect(() => {
    const status = searchParams.get('verifyEmail')
    if (!status) return
    if (status === 'success') {
      toast.success(t('login.verify_email.success'))
    } else {
      const known = ['expired', 'notfound', 'invalid', 'error']
      toast.error(t(`login.verify_email.${known.includes(status) ? status : 'error'}`))
    }
    searchParams.delete('verifyEmail')
    setSearchParams(searchParams, { replace: true })
  }, [searchParams, setSearchParams, t])

  if (getUserLoading) {
    return <Loader />
  }

  return (
    <AuthShell title={t('login.title')}>
      <LoginForm />
      <SocialLoginButtons />
      {/* one filled button per form: the search request without an account
          is the secondary way in */}
      <Button
        variant="outlined"
        size="lg"
        className="w-full"
        onClick={() => {
          if (user) {
            navigate('/login/create-request-without-auth')
            return
          }
          setOpenApproveEmail(true)
        }}
      >
        {t('create_request_without_auth')}
      </Button>
      <div className="flex flex-wrap gap-x-2 items-center justify-center text-[0.9375rem]">
        <p className="m-0 text-ink-2">{t('login.no_account')}</p>
        <Link
          to="/registration"
          className="min-h-11 inline-flex items-center font-bold text-brand-ink hover:underline"
        >
          {t('login.register')}
        </Link>
      </div>
      <ApproveRequestEmail open={openApproveEmail} handleClose={() => setOpenApproveEmail(false)} />
      <Outlet />
    </AuthShell>
  )
}

export default Login
